<template>
  <div class="box-structure elevation-1">
    <!-- Card Header with Filters -->
    <div class="d-flex btw-graph-cntrl">
      <div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p
          class="text-p-title"
          v-html="title"
        ></p>
      </div>
    </div>

    <!-- Responsive Table Container -->
    <div class="target-table mt-3">
      <!-- Headers -->
      <div class="table-head d-flex">
        <div
          v-for="(header, index) in headers"
          :key="index"
          class="col font-weight-semibold text-left"
        >
          {{ header }}
        </div>
      </div>

      <!-- Loading State -->
      <div
        v-if="loading"
        class="d-flex align-center justify-center py-12"
      >
        <v-progress-circular
          indeterminate
          color="#1f4978"
          size="36"
          width="3"
        ></v-progress-circular>
      </div>

      <!-- Table Body -->
      <template v-else>
        <!-- Empty State -->
        <div
          v-if="rows.length === 0"
          class="table-row d-flex justify-center align-center py-12 text-muted font-weight-medium text-center"
        >
          No Customer found
        </div>

        <!-- Rows -->
        <!-- TODO: Map dynamic dataset rows -->
        <div
          v-for="(row, rIndex) in rows"
          :key="rIndex"
          class="table-row d-flex"
        >
          <div
            v-for="(header, hIndex) in headers"
            :key="hIndex"
            class="col text-left text-truncate py-2"
          >
            {{ getColValue(row, hIndex) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiDownload } from '@mdi/js'

export default {
	name: 'DashboardTableCard',
	props: {
		title: {
			type: String,
			required: true,
		},
		headers: {
			type: Array,
			required: true,
		},
		rows: {
			type: Array,
			required: true,
		},
		showDateFilter: {
			type: Boolean,
			default: true,
		},
		showOutletFilter: {
			type: Boolean,
			default: true,
		},
		initialFilter: {
			type: String,
			default: 'Monthly',
		},
		initialOutlet: {
			type: String,
			default: 'Salmiya',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const currentFilter = ref(props.initialFilter)
		const currentOutlet = ref(props.initialOutlet)

		const timeRanges = ['Daily', 'Weekly', 'Monthly', 'Year']
		const outlets = ['All', 'Salmiya', 'Hawally', 'Farwaniya']

		const getColValue = (row, index) => (row && row[index] !== undefined ? row[index] : '')

		const downloadData = () => {
			emit('show-notification', {
				message: `Exported dataset "${props.title.replace(/<br\s*\/?>/gi, ' ')}" to Excel/CSV successfully!`,
				type: 'success',
			})
		}

		return {
			currentFilter,
			currentOutlet,
			timeRanges,
			outlets,
			getColValue,
			downloadData,
			icons: { mdiDownload },
		}
	},
}
</script>

<style lang="scss" scoped>
.box-structure {
	background: #fff;
	border-radius: 20px;
	padding: 20px;
	height: 100%;
}

.btw-graph-cntrl {
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.filter-sec {
	display: flex;
	gap: 10px;
	align-items: center;
	background: #f1f5fd;
	padding: 4px 10px;
	border-radius: 50px;
}

.dropdown-pill {
	background: #fff;
	padding: 6px 12px;
	border-radius: 20px;
	font-size: 13px;
	color: #1f4978;
	display: flex;
	align-items: center;
	gap: 5px;
	font-weight: 600;
	cursor: pointer;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	transition: all 0.2s ease;

	&:hover {
		background: #fcfcfc;
	}
}

.dropdown-pill span {
	color: #767676;
	font-weight: 500;
}

.download-icon {
	background: #fff;
	padding: 5px;
	border-radius: 50%;
	color: #1f4978;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	transition: all 0.2s ease;

	&:hover {
		background: #fcfcfc;
		transform: scale(1.05);
	}
}

.target-table {
	margin-top: 15px;
	width: 100%;
	overflow-x: auto;
}

.table-head {
	font-size: 13px;
	color: #9ca3af;
	border-bottom: 1px solid #e5e7eb;
	padding-bottom: 10px;
	min-width: 320px;
}

.table-row {
	font-size: 14px;
	color: #374151;
	padding: 10px 0;
	border-bottom: 1px solid #f1f5f9;
	min-width: 320px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #fafbfc;
	}
}

.table-head .col,
.table-row .col {
	flex: 1;
	min-width: 0;
	padding-left: 4px;
	padding-right: 4px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.table-row:last-child {
	border-bottom: none;
}

.text-p-title {
	color: #767676;
	font-weight: 500;
	font-size: 15px;
	line-height: 1.4;
	margin: 0;
}
</style>
